import dayjs from "dayjs"
import { useEffect, useState } from "react"
import ModalImage, { Lightbox } from "react-modal-image"
import ImageTagsDetails from "../SocialTrendsTags/ImageTagsDetails"
import SimilarProduct from "./SimilarProduct"
import TrendsArgument from "./TrendsArgument"
import Collection from "../V2Leaderboard/Collection"
import ColorImage from "./ColorImages"
import SimilarProductsReviewSummary from "./SimilarProductsReviewSummary"

function getImageUrl(design) {
  if (design && design.trendingColors && design.trendingColors[design.category] && design.trendingColors[design.category].images && design.trendingColors[design.category].images[0] && design.trendingColors[design.category].images[0].imageUrl) {
    return design.trendingColors[design.category].images[0].imageUrl
  }
  if (design && design.trendingColors && design.trendingColors[design.originalCategory] && design.trendingColors[design.originalCategory].images && design.trendingColors[design.originalCategory].images[0] && design.trendingColors[design.originalCategory].images[0].imageUrl) {
    return design.trendingColors[design.originalCategory].images[0].imageUrl
  }
  return design.imageUrl

}

function Design({ design, category, allCollectionNames, addImageToCollection, collectionSets, designSimilarProductsCollectionSets, curator, fetchCollections, addSimilarProductToCollection, gender }) {
  const [wrapperHeight, setWrapperHeight] = useState(0)
  const [imageWidth, setImageWidth] = useState(200)
  const [showLightbox, setShowlightbox] = useState(false)
  const [designImageUrl, setDesignImageUrl] = useState(getImageUrl(design))
  const handleOnload = (e) => {
    const parentWidth = e.nativeEvent.target.parentElement.scrollWidth
    const imageWidth = e.nativeEvent.target.width
    setImageWidth(imageWidth)

    setWrapperHeight(Math.floor((parentWidth - imageWidth) / 2))
  }

  useEffect(() => {
    setDesignImageUrl(getImageUrl(design))
  }, [design])

  return <div className=" border  bg-slate-100 py-1 border-slate-400">
    <div className={`flex w-auto lg:h-[90vh] flex-wrap lg:flex-nowrap max-w-[100vw]`} >
      <div className="flex flex-col">
        <div className="w-full lg:w-[44vw] shrink relative h-full flex justify-center">
          {
            showLightbox ? <Lightbox
              medium={designImageUrl}
              large={designImageUrl}
              onClose={() => {
                setShowlightbox(false)
              }}
            /> : null
          }
          <img src={designImageUrl}
            className="w-auto h-full"
            loading="lazy"
            onLoad={handleOnload}
            onClick={() => {
              setShowlightbox(true);
            }} />
          <div className={`absolute top-4 flex justify-between p`} style={{ left: `${16 + wrapperHeight}px`, width: `${imageWidth}px` }}>
            <div className="font-semibold text-xs lg:text-lg" style={{ textShadow: " 0.2px 0.2px 0.5px #ffffff, -0.2px -0.2px 0.5px #ffffff " }}>{dayjs(new Date(design.timeStamp)).format('D MMM, YYYY')}</div>
            <div className="relative w-20 mr-4 mt-10">
              <Collection image={design} collections={allCollectionNames} addImageToCollection={addImageToCollection} collectionSets={collectionSets} fetchCollections={fetchCollections} />
            </div>
          </div>

        </div>
        <div className="w-full flex justify-center">

          {curator ? <div className="text-blue-500" style={{ width: `${imageWidth}px` }}>
            <a href={design.postUrl} target="_blank" >{design.username}</a>
          </div> : null}

        </div>
      </div>
      <div className="px-1 w-full lg:w-[54vw] shrink ">
        <div className="w-full h-full flex flex-col justify-between">
          <div className="max-h-[60vh] lg:h-1/2 shrink-0 overflow-hidden flex flex-col">
            <div className="w-content text-xs lg:text-lg">
              {curator ? <ImageTagsDetails mediaId={design.mediaId} /> : null}
              <p><span className="font-semibold">CATEGORY: </span>{design.seasonalMetadata['Recommended Category'] || design.category}</p>
              <p><span className="font-semibold">AVAILABILITY: </span>{design.seasonalMetadata['Recommendation Argument'] ? design.seasonalMetadata['Recommendation Argument'].filter(a => (a == 'Exact design unavailable' || a == 'Less copies in India')).join(', ') : null}
              </p>
              {design.seasonalMetadata && design.seasonalMetadata['Recommendation'] ? <div><span className="font-semibold">SUGGESTION: </span>{
                design.seasonalMetadata['Recommendation'].map(item => {
                  if (item == 'Make in small quantity') return 'Low-Medium Risk, Make in Small quantity'
                  if (item == 'Make in medium quantity') return 'Low Risk, Make in Medium quantity'
                  if (item == 'Make in large quantity') return 'No Risk, Make in Large quantity'
                  return item

                }).join(', ')
              }</div> : null}
              {design.seasonalMetadata && design.seasonalMetadata['Recommendation Argument'] ? <div>
                <p ><span className="font-semibold">ARGUMENT</span> :
                  {design.seasonalMetadata['Recommendation Argument'].filter(a => (a != 'Exact design unavailable' && a != 'Less copies in India')).sort((a, b) => {
                    if (a == 'Proven sales') return 1
                    if (b == 'Proven sales') return -1
                    return 0
                  }).join(', ')
                  } <SimilarProductsReviewSummary products={design.SimilarProducts} /></p>
              </div> : null}
            </div>
            {
              design.trendsArgument ? <TrendsArgument design={design} category={category} trends={design.trendsArgument} /> : null
            }
          </div>
          <div className="lg:h-1/2 shrink-0 p-1 border-t">
            {
              design.SimilarProducts ?
                <>
                  <h3 className="font-semibold text-xs lg:text-lg">SALES PROOF FROM SIMILAR DESIGNS:</h3>
                  <div className="flex overflow-x-scroll w-full h-full">
                    {design.SimilarProducts
                      .sort((a, b) => ((b.countOfReviews || 0) - (a.countOfReviews || 0)))
                      .map((prod, i) => <SimilarProduct
                        product={prod}
                        key={i}
                        addSimilarProductToCollection={addSimilarProductToCollection}
                        allCollectionNames={allCollectionNames}
                        fetchCollections={fetchCollections}
                        collectionSets={designSimilarProductsCollectionSets}
                      />)}
                  </div>
                </> : null
            }
          </div>


        </div>


      </div>

    </div>

    <div className={`w-auto overflow-x-scroll px-5 mt-6`}>
      <a href={`/news-feed?gender=${gender}&category=${design.originalCategory}&sort=rog&geography=All&alltrends=color`} target="_blank" className="font-semibold text-blue-500 hover:text-blue-600 active:text-blue-700 text-xs lg:text-lg w-full text-center"><div>SEE ALTERNATIVE COLOR SUGGESTIONS<img loading="lazy" src="/color-palette.png" className="inline-block h-4" /></div></a>
      {
        design.trendingColors && design.trendingColors[design.originalCategory]
          ? <ColorImage colors={design.trendingColors[design.originalCategory]} />
          : null
      }
    </div>
  </div >

}

export default Design
